var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangleRed = function SvgAlertTriangleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.165 7.501a.834.834 0 0 1 1.667 0v3.334a.834.834 0 0 1-1.667 0V7.5Zm0 5.834a.834.834 0 1 1 1.667 0 .834.834 0 0 1-1.667 0Zm8.22 1.96c-.19.338-.562.54-.994.54H3.605c-.432 0-.804-.202-.994-.54a.81.81 0 0 1 .015-.847L9.018 3.85c.39-.645 1.57-.645 1.96 0l6.393 10.598c.222.367.105.69.015.848Zm1.414-1.708L12.406 2.988c-.5-.827-1.4-1.32-2.408-1.32s-1.908.493-2.407 1.32l-6.393 10.6a2.478 2.478 0 0 0-.038 2.527c.482.856 1.42 1.386 2.445 1.386H16.39c1.026 0 1.963-.53 2.446-1.386a2.478 2.478 0 0 0-.038-2.528Z",
    fill: "#D23B12"
  })));
};
export default SvgAlertTriangleRed;